import { render, staticRenderFns } from "./OverviewGraphic.html?vue&type=template&id=b50490fe&scoped=true&lang=html&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./OverviewGraphic.scss?vue&type=style&index=0&id=b50490fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b50490fe",
  null
  
)

export default component.exports